import {
  GearIcon,
  UsersIcon,
  EyeOpenIcon,
  NotificationsIcon,
} from '@frontend/legacy-components';

import { SUPPLIER_ROLES } from 'constants/all';

const notifications = {
  url: '/notifications',
  key: 'notifications',
  title: 'Notifications',
  icon: <NotificationsIcon />,
};

const resources = {
  external: true,
  url: 'https://help.paperlessparts.com',
  key: 'resources',
  title: 'Resources',
  icon: <EyeOpenIcon />,
};

const settings = {
  url: '/settings/profile/info',
  key: 'settings',
  title: 'Settings',
  icon: <GearIcon />,
};

const team = {
  url: '/team',
  key: 'team',
  title: 'Team',
  supplierRoleName: SUPPLIER_ROLES.TEAM,
  icon: <UsersIcon />,
};

const partLibraryConfig = [notifications];

const quotingToolConfig = [settings, team, resources, notifications];

export { partLibraryConfig, quotingToolConfig };
